// "use strict";
// const sentry_release = process.env.MIX_SENTRY_RELEASE;
// process.env.RELEASE_VERSION = process.env.MIX_SENTRY_RELEASE;
// module.exports = {
// 	NODE_ENV: '"dev"',
// 	RELEASE_VERSION: `"${sentry_release}"`
// };

import 'babel-polyfill';
import Popper from 'popper.js';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

const sentryDSN = process.env.MIX_SENTRY_LARAVEL_DSN;

window.CoreEcho = null;
window.ClientEcho = null;
//https://ff8f1e259cd24c71b492b43808749217@sentry.io/1492767
try {
	const Vue = require('vue');
	window.Vue = Vue;

	Sentry.init({
		dsn:sentryDSN,
		integrations: [
			new Integrations.Vue({
				Vue,
				attachProps: true
			}),
			new Integrations.RewriteFrames()
		],
		release: process.env.MIX_SENTRY_RELEASE
	});
	// window.Vue.config.performance = true;
	// console.log('----------------------- VUE -------------------------', 'Vue',Vue);

	window._ = require('lodash');

	window.$ = window.jQuery = require('jquery');

	window.select2 = require('select2');
// window.Tether = require('tether');
	window.Tether = require('tether');



	window.Popper = Popper;

	require('./config/vueComponents');
	/**
	 * We'll load the axios HTTP library which allows us to easily issue requests
	 * to our Laravel back-end. This library automatically handles sending the
	 * CSRF token as a header based on the value of the "XSRF" token cookie.
	 */
	window.axios = require('axios');

	window.axios.defaults.headers.common = {
		// 'X-CSRF-TOKEN': window.Laravel.csrfToken,
		'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
		'X-Requested-With': 'XMLHttpRequest'
	};

	/**
	 * Include EchoServer Stuff
	 */
	require('./config/echoServer');

	/**
	 * Material Design plugins
	 */
	require('./config/materialDesign');
	require('hideshowpassword');

	window.Dropzone = require('dropzone');
	window.password = require('password-strength-meter');

	require('./bootstrap');
}catch (e) {
	console.error('e',e);
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js